
import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { ClubOfferModel } from '@core/models/domains/hotel';
import { PortalModule } from '@angular/cdk/portal';

@Component({
  selector: 'iho-plus-section',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    NgOptimizedImage,
    MatBottomSheetModule,
    MatButtonModule
  ],
  templateUrl: './ihoplus.component.html',
  styleUrls: ['./ihoplus.component.scss'],
})
export class IhoPlusComponent {

  _bottomSheet = inject(MatBottomSheet)
  router = inject(Router)
  route = inject(ActivatedRoute)

  @Output() scrollToRooms = new EventEmitter<boolean>(false)

  @Input() hotelName = ''

  _dataSource: any = [] 
  get dataSource(): any {
    return this._dataSource
  }
  @Input() set dataSource(value: ClubOfferModel[]) {
    this._dataSource = value.map((each) => ({
      ...each,
      Icon: this.findIcon(each.ClubOfferId)
    }))
  }

  @ViewChild('bottomSheetTemplate') template: any

  findIcon(id: number): string {
    let foundedItem = Object.entries(this.CLUB_OFFERS).find(([key, _]) => String(id) === key)
    if(!foundedItem) return 'ico-Like'

    return foundedItem[1] // className
  }

  closeBottomSheet() {
    this._bottomSheet.dismiss()
  }

  openBottomSheet() {
    this._bottomSheet.open(this.template)
  }

  goToRooms() {
    this.closeBottomSheet()
    setTimeout(() => {
      this.scrollToRooms.emit(true)
    }, 400);
  }

  CLUB_OFFERS = {
    1: 'ico-Confrance',
    2: 'ico-Gym',
    3: 'ico-ArrivalTime',
    4: 'ico-DepartureTime',
    5: 'ico-Breakfast',
    6: 'ico-Pool',
    7: 'ico-Transfer1',
    8: 'ico-Laundry',
    9: 'ico-Sofa',
    10: 'ico-Picture',
    11: 'ico-Like',
    12: 'ico-HotelsApartemant',
    13: 'ico-Billiards',
    14: 'ico-Foosball',
    15: 'ico-Childlaw',
    16: 'ico-Restaurant',
    17: 'ico-TagSale',
    18: 'ico-Cinema',
    19: 'ico-Transfer',
    20: 'ico-Pool',
    21: 'ico-TagSale',
    22: 'ico-Boating',
    23: 'ico-Transfer1',
    24: 'ico-Breakfast',
    25: 'ico-Transfer',
    26: 'ico-CloseCircle',
    27: 'ico-Coffee',
    28: 'ico-Pool',
  }
}



// "ترانسفر حرم"14 //duplicate ID 
// "ترانسفر بازار"22
// "گشت شهری رایگان"14
// "تخفیف ویژه کافی شاپ و رستوران"17